import { createReducer, on, Action } from '@ngrx/store';

import * as PacksNotSavedChangesActions from './master-template-not-saved-changes.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { MasterTemplateResponseData } from '@cpak/adp-cpak-bff-service-models';

export const MASTER_TEMPLATE_NOT_SAVED_CHANGES_FEATURE_KEY = 'masterTemplateNotSavedChanges';

export interface MasterTemplateNotSavedChangesEntity {
  id: string;
  // should contain the following properties: products, categories, attributeTypes, boms
  templateData: Pick<MasterTemplateResponseData, 'categories'>;
}

export interface MasterTemplateNotSavedChangesPartialState {
  readonly [MASTER_TEMPLATE_NOT_SAVED_CHANGES_FEATURE_KEY]: EntityState<MasterTemplateNotSavedChangesEntity>;
}

export const masterTemplateNotSavedChangesAdapter: EntityAdapter<MasterTemplateNotSavedChangesEntity> =
  createEntityAdapter<MasterTemplateNotSavedChangesEntity>();

export const initialMasterTemplateNotSavedChangesState: EntityState<MasterTemplateNotSavedChangesEntity> =
  masterTemplateNotSavedChangesAdapter.getInitialState();

const reducer = createReducer(
  initialMasterTemplateNotSavedChangesState,
  on(PacksNotSavedChangesActions.updateNotSavedMasterTemplateChanges, (state, { templateId, templateData }) => {
    const item = {
      id: templateId,
      templateData,
    };
    return masterTemplateNotSavedChangesAdapter.upsertOne(item, state);
  }),
  on(PacksNotSavedChangesActions.removeNotSavedChangesForMasterTemplate, (state, { templateId }) =>
    masterTemplateNotSavedChangesAdapter.removeOne(templateId, state)
  ),
  on(PacksNotSavedChangesActions.removeNotSavedChangesForAllTemplates, state =>
    masterTemplateNotSavedChangesAdapter.removeAll(state)
  )
);

export function masterTemplateNotSavedChangesReducer(
  state: EntityState<MasterTemplateNotSavedChangesEntity> | undefined,
  action: Action
): EntityState<MasterTemplateNotSavedChangesEntity> {
  return reducer(state, action);
}
